import axios from "axios";
import { baseURL } from "../globals/constants";
import { showErrorToast } from "../utils/Toast";

const headers = () => ({ headers: { Accept: "application/json", Authorization: `Bearer ${localStorage.getItem("access_token")}` } });
const url = `${baseURL}/v1/legal`;

export type LegalType = "terms" | "dpa" | "subprocessors" | "privacy-customers" | "employee-information" | "insight-small-groups" | "insight-persons";
export const LEGAL_TYPES: LegalType[] = ["terms", "dpa", "subprocessors", "privacy-customers", "employee-information", "insight-small-groups", "insight-persons"];

export interface LegalDocument {
  type: LegalType;
  version: number;
  title: string;
  content: string;
  draft: boolean;
  requiresAcceptance: boolean;
  effectiveAt: string;
  publishedBy?: string;
  createdAt?: string;
}
export interface Acceptance {
  type: LegalType;
  version: number;
  acceptedAt: string;
  companyName: string;
  cvr: string;
  userId: string;
  ip: string;
  userAgent: string;
}
export interface MissingTenant {
  tenantId: string;
  companyName: string;
  email: string;
  cvr: string;
  missing: { type: LegalType; version: number; title: string }[];
}

export const getLegalHistory = async (): Promise<LegalDocument[]> => {
  try {
    return (await axios.get(`${url}/history`, headers())).data;
  } catch (error: any) {
    showErrorToast(error?.response?.data?.message || "Could not load the documents", false);
    return [];
  }
};

export const publishLegalDocument = async (body: {
  type: LegalType;
  title: string;
  content: string;
  draft: boolean;
  requiresAcceptance: boolean;
  effectiveAt?: string;
  notify: boolean;
}): Promise<LegalDocument | null> => {
  try {
    return (await axios.post(`${url}/publish`, body, headers())).data;
  } catch (error: any) {
    showErrorToast(error?.response?.data?.message || "Could not publish", false);
    return null;
  }
};

export const getMissingAcceptances = async (): Promise<MissingTenant[]> => {
  try {
    return (await axios.get(`${url}/missing`, headers())).data;
  } catch {
    return [];
  }
};

export const getTenantAcceptances = async (tenantId: string): Promise<{ missing: MissingTenant["missing"]; acceptances: Acceptance[] } | null> => {
  try {
    return (await axios.get(`${url}/acceptances/${tenantId}`, headers())).data;
  } catch {
    return null;
  }
};
